"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tanDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var tanDependencies = exports.tanDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createTan: _factoriesAny.createTan
};